// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","holdingRow":"_2aNYblhCmK0QXzFgCq4X39","holdingColumn":"_2jGkllrHm8wihQqb-JP2jh"};